import { Fragment, Node, Slice } from "@tiptap/pm/model";

interface EditorContext {
  doc: {
    type: {
      schema: any; // Using any here since Schema type is causing issues
    };
  };
}

interface TextNode {
  text: string;
  type: "text";
}

interface HardBreakNode {
  type: "hardBreak";
}

interface ParagraphNode {
  content: (TextNode | HardBreakNode)[];
  type: "paragraph";
}

export const clipboardTextParser = (text: string, context: EditorContext) => {
  const blocks = text.replace(/\r\n?|\n/g, "\n").split("\n");
  const nodes: Node[] = [];

  blocks.forEach((line: string, index: number) => {
    if (line.length > 0) {
      const newNode: ParagraphNode = {
        type: "paragraph",
        content: [{ type: "text", text: line }],
      };

      // If the next line is empty, add a hard break
      if (blocks[index + 1]?.length == 0) {
        newNode.content.push({
          type: "hardBreak",
        });
      }
      nodes.push(Node.fromJSON(context.doc.type.schema, newNode));
    }
  });

  const fragment = Fragment.from(nodes);
  return Slice.maxOpen(fragment);
};
